import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

import { LoadingService } from '../services/loading.service'
import { SettingsProvider } from '../services/settings'
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(private http: HttpClient, private toast: ToastrService, private load: LoadingService, private router: Router) { }

  getRequestErrorNormal(endPoint: string, fields?: any){

    let params = new HttpParams();

    if(fields != undefined){
      for (const key in fields) {
        if (Object.prototype.hasOwnProperty.call(fields, key)) {
          params = params.set(`${key}`, `${fields[key]}`);
        }
      }
    }
    this.load.loadingShowAlt();
    return this.http.get( SettingsProvider.getUrl(endPoint), { params })
    .pipe(
      tap( () => { this.load.dismissAlt(); } )
    )
  }

  get_request(endPoint: string, fields?: any, customError: boolean = false, customLoading: boolean = false, hasApi: boolean = true){

    let params = new HttpParams();

    if(fields != undefined){
      for (const key in fields) {
        if (Object.prototype.hasOwnProperty.call(fields, key)) {
          params = params.set(`${key}`, `${fields[key]}`);
        }
      }
    }
    if(!customLoading) {
      this.load.loadingShowAlt();
    }
    return this.http.get( hasApi ? SettingsProvider.getUrl(endPoint) : endPoint, { params })
    .pipe(
      catchError((error: any) => {
        if(!customLoading) {
          this.load.dismissAlt();
        }
        if(!customError) {
          this.errorMessage(error);
          return of({})
        } else {
          return throwError(error);
        }
      }),
      tap( () => {
        if(!customLoading) this.load.dismissAlt();
      })
    )
  }

  post_request(endPoint: string, body?: any, customError: boolean = false, customLoading: boolean = false, hasApi: boolean = true){
    if(!customLoading) {
      this.load.loadingShowAlt();
    }
    if(body === undefined){
      return this.http.post( hasApi ? SettingsProvider.getUrl(endPoint) : endPoint, {})
      .pipe(
        catchError((error: any) => {
          if(!customLoading) {
            this.load.dismissAlt();
          }
          if(!customError) {
            this.errorMessage(error);
            return of({})
          } else {
            return throwError(error);
          }
        }),
        tap( () => {
          if(!customLoading) this.load.dismissAlt();
        })
      )
    }else{
      return this.http.post( SettingsProvider.getUrl(endPoint), body)
      .pipe(
        catchError((error: any) => {
          if(!customLoading) {
            this.load.dismissAlt();
          }
          if(!customError) {
            this.errorMessage(error);
            return of({})
          } else {
            return throwError(error);
          }
        }),
        tap( () => {
          if(!customLoading) this.load.dismissAlt();
        })
      )
    }
  }

  put_request(endPoint: string, body?: any, customError: boolean = false, customLoading: boolean = false){
    if(!customLoading) {
      this.load.loadingShowAlt();
    }
    if(body === undefined){
      return this.http.put( SettingsProvider.getUrl(endPoint), {})
      .pipe(
        catchError((error: any) => {
          if(!customLoading) {
            this.load.dismissAlt();
          }
          if(!customError) {
            this.errorMessage(error);
            return of({})
          } else {
            return throwError(error);
          }
        }),
        tap( () => {
          if(!customLoading) this.load.dismissAlt();
        })
      )
    }else{
      return this.http.put( SettingsProvider.getUrl(endPoint), body)
      .pipe(
        catchError((error: any) => {
          if(!customLoading) {
            this.load.dismissAlt();
          }
          if(!customError) {
            this.errorMessage(error);
            return of({})
          } else {
            return throwError(error);
          }
        }),
        tap( () => {
          if(!customLoading) this.load.dismissAlt();
        })
      )
    }
  }

  errorMessage(error: any){
    if(error.error?.errors?.length > 0){
      error.error.errors.forEach((element: any) => {
        this.toast.error( element , error.error.message, {timeOut: 5000, closeButton: true, progressBar: true} );
      });
    }

    if(error.status == 401){
      this.toast.error( error.message , 'Error', {timeOut: 5000, closeButton: true, progressBar: true} );
      localStorage.removeItem('auth');
      this.router.navigate(['/login']);
    }

    if(error.status == 422){
      this.toast.error( error.message , 'Error', {timeOut: 5000, closeButton: true, progressBar: true} );
    }

    // if(error.status == 400){
    //   this.toast.error( error.error.message , 'Error', {timeOut: 5000, closeButton: true, progressBar: true} );
    //   this.router.navigate(['/home']);
    // }
  }
}

